import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosPaymentInstance } from "../../../common/utils/AxiosInstance";

import { AxiosPropertyInstance } from "../../../common/utils/AxiosInstance";

export const getOrders = createAsyncThunk(
  "getOrders",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `v1/customer/order/overview?pageSize=10&pageIndex=${pageNumber}`;

    try {
      const res = await AxiosPaymentInstance.post(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getOrderstoCheckPayemnt = createAsyncThunk(
  "getOrderstoCheckPayemnt",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `v1/customer/transaction/overview?pageSize=10&pageIndex=${pageNumber}`;

    try {
      const res = await AxiosPaymentInstance.post(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getunreadMsgsOrders = createAsyncThunk(
  "getunreadMsgsOrders",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `v1/customer/order/overview?pageSize=60&pageIndex=${pageNumber}`;

    try {
      const res = await AxiosPaymentInstance.post(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getunseenPaymentsInTransactions = createAsyncThunk(
  "getunseenPaymentsInTransactions",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));

    const url = `v1/customer/transaction/overview?pageSize=50&pageIndex=${pageNumber}`;

    try {
      const res = await AxiosPaymentInstance.post(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getOrderInfo = createAsyncThunk(
  "getOrderInfo",
  async (orderId, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    // No id ⇒ skip: an empty orderId makes this GET /api/payment/order/ (404).
    if (!orderId) return { response: null };
    const URL = `/order/${orderId}`;
    try {
      const res = await AxiosPaymentInstance.get(URL, {
        headers: { "x-auth-token": token },
      });
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getOrdersfromPagination = createAsyncThunk(
  "getOrdersfromPagination",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `/order/user-orders/overview?pageSize=5&pageIndex=${pageNumber}`;

    // try {
    //    const res = await AxiosPaymentInstance.post(url, data, {
    //       headers: { "x-auth-token": token }
    //    })
    //
    //    return { response: JSON.parse(JSON.stringify(res)) }
    // } catch (error) {
    //
    //    return rejectWithValue(JSON.parse(JSON.stringify(error)))
    // }
  }
);

// The count API has no refunded total, so read it from the order list's
// pagination. Refunded orders join rejected ones in the "Unsuccessful" card.
export const getRefundedOrdersCount = createAsyncThunk(
  "getRefundedOrdersCount",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = "v1/customer/order/overview?pageSize=1&pageIndex=1";

    try {
      const res = await AxiosPaymentInstance.post(
        url,
        { filter: { status: ["REFUNDED"] } },
        { headers: { "x-auth-token": token } }
      );

      return { total: Number(res?.data?.pagination?.total) || 0 };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getTotalOrdersCount = createAsyncThunk(
  "getTotalOrdersCount",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = "v1/customer/order/overview/count";

    try {
      const res = await AxiosPaymentInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getDocFilterReferences = createAsyncThunk(
  "getDocFilterReferences",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = "/static/filters/documents.json";

    try {
      const res = await AxiosPropertyInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getServiceReferences = createAsyncThunk(
  "getServiceReferences",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = "/static/filters/services.json";

    try {
      const res = await AxiosPropertyInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getStateReferences = createAsyncThunk(
  "getStateReferences",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = "/static/states/index.json";

    try {
      const res = await AxiosPropertyInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getStatusReferences = createAsyncThunk(
  "getStatusReferences",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = "/static/filters/order-status.json";

    try {
      const res = await AxiosPropertyInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

// credits Board and table

export const getCreditsData = createAsyncThunk(
  "getCreditsData",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `v1/customer/credit/history?pageSize=10&pageIndex=${pageNumber}`;

    try {
      const res = await AxiosPaymentInstance.post(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

//  get transcation data

export const getTrasactionsData = createAsyncThunk(
  "getTrasactionsData",
  async ({ data, pageNumber }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));

    const url = `v1/customer/transaction/overview?pageSize=10&pageIndex=${pageNumber}`;

    try {
      const res = await AxiosPaymentInstance.post(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getSingleorderdata = createAsyncThunk(
  "getSingleorderdata",
  async (id, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));

    // Bail out when there's no order id. Without this guard the request becomes
    // GET /api/payment/order/ (empty id) — which 404s — and it fired on every
    // page because the Navbar dispatches this with an empty paymentOrderId on
    // mount. No id ⇒ nothing to fetch, so skip the request entirely.
    if (!id) return { response: null };

    const url = `/order/${id}`;

    try {
      const res = await AxiosPaymentInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

// chat message handles

export const sendMsg = createAsyncThunk(
  "sendMsg",
  async (data, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const orderId = data?.orderId;
    delete data?.orderId;
    const url = `/v1/customer/order/chat/${orderId}/send-msg`;
    try {
      const res = await AxiosPaymentInstance.put(url, data, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);
export const readChatMsg = createAsyncThunk(
  "readChatMsg",
  async (orderId, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const URL = `v1/customer/order/chat/${orderId}/read-msg`;
    const data = {};
    try {
      const res = await AxiosPaymentInstance.put(URL, data, {
        headers: { "x-auth-token": token },
      });
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const sendFileInChat = createAsyncThunk(
  "sendFileInChat",
  async (data, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const orderId = data?.orderId;
    delete data?.orderId;
    const url = `/v1/customer/order/chat/${orderId}/upload-doc`;
    const body = data?.file;
    try {
      const res = await AxiosPaymentInstance.put(url, body, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getUserTransationsData = createAsyncThunk(
  "getUserTransationsData",
  async (_, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));

    const url = "v1/customer/transaction/overview/count";

    try {
      const response = await AxiosPaymentInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(response)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getOrderPayments = createAsyncThunk(
  "getOrderPayments",
  async ({ orderId }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));

    const url = `v1/customer/order/payment-link/${orderId}`;

    try {
      const response = await AxiosPaymentInstance.get(url, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(response)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);
